module.exports = __webpack_public_path__ + "img/smb_circle.1c9ded82.svg";